const MultiGraphWrapper: React.FC = ({ children }) => {
  return (
    <div className="grid grid-flow-row sm:grid-flow-col auto-cols-fr gap-12 pt-6 px-6">
      {children}
    </div>
  )
}

export default MultiGraphWrapper
